import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Vendor } from '../../models/domain/vendor';
import { VendorItemArray, VendorItem } from '../../models/domain/vendor.item';
import { EditVendorItemIgnoreRequest } from '../../models/ss-api/requests/edit.vendor.item.ignore.request';
import { Router } from '@angular/router';

export interface IVendorItemsDialogModel {
    title: string;
    subTitle: string;
    message: string;
    Vendor: Vendor
}


@Component({
    selector: 'stats-vendor-items-dialog',
    styleUrls: ['./stats.vendor.items.dialog.css'],
    templateUrl: './stats.vendor.items.dialog.html'
})
export class StatsVendorItemsDialog extends DialogComponent<IVendorItemsDialogModel, boolean> implements IVendorItemsDialogModel, OnInit {

    IsBusy: boolean = false;

    title: string;
    subTitle: string;
    message: string;

    Vendor: Vendor;

    VendorItems: VendorItemArray = new VendorItemArray();

    constructor(dialogService: DialogService,
        private sweetAlertService: SweetAlertService,
        private api: ssApiService,
        public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.getVendorItems();
    }

    getVendorItems() {
        this.IsBusy = true;
        let disposable = this.api.GetVendorItems(this.Vendor.ID).subscribe(response => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.VendorItems = response.Data;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }


    IgnoreItem(Item: VendorItem, IgnoreMe: boolean = true) {
        this.IsBusy = true;

        let request = new EditVendorItemIgnoreRequest;
        request.ID = Item.ID;
        request.Ignore = IgnoreMe;

        let disposable = this.api.EditVendorItemIgnore(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'Ignored Successfully',
                    text: 'Ignored vendor item without any errors',
                    timer: 1500
                }).then(() => { }, () => { })
            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { })
            }
            disposable.unsubscribe();
            this.IsBusy = false;
            Item.IgnoreStatistics = IgnoreMe;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

}
